import React, { useContext, useEffect } from 'react'
import { VehicleContext } from '../Context/VehicleContext';

const UnlinkedFeaturedVehicles = ({title, items}) => {
    const {getVehicleData,vehicleData, featuredVehicles,numberFormatter} = useContext(VehicleContext);

  useEffect(() => {
      console.log("home page useEffect");

      getVehicleData();

  }, []);
    return (
        <>
        <div className='featured-vehicles-wrap unlinked-fv py-0 mt-4'>
        <h2 className='mt-0 mb-4'>{title}</h2>
        <div className='row'>
            {/* {featuredVehicles.filter(vehicle => vehicle.make == '').map((v,i) => */} 
                {/* Comment out After setup inventory from url     */}
            {featuredVehicles && featuredVehicles.slice(0, (items || 4)).map((car, index) =>
                    <div className={`${items ? 'col-md-4' : 'col-md-3'} col-6 mb-3"`} key={index}>
                        <div className='inner'>
                            <article className="cs-card cs-card--2 fv-box">
                                <div className="cs-card__img fv-top"
                                    style={{
                                        backgroundImage: `url(${car.images[0]})`,
                                    }}
                                ></div>
                                <a href="#" className="cs-card_link">
                                    <div className="cs-card__img--hover fv-top"
                                        style={{
                                            backgroundImage: `url(${car.images[0]})`,
                                        }}></div>
                                </a>
                                <div className="fv-bottom">
                                    <div className="sm-title text-theme font-bold">{car.vehicle_name}</div>
                                    <div className="d-flex align-items-center justify-content-between mt-1">
                                        <div className="sm-title">{numberFormatter(car.price, true)}</div>
                                        <div className="sm-title opacity-0-7">{numberFormatter(car.mileage)}</div>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>
            )}
            </div>
            </div>
        </>
    )
}

export default UnlinkedFeaturedVehicles